import React from 'react';
import { Button } from '@shopify/polaris';

const FreeSubscriptionBlock = ({ type, sub, currentPlan, t }) => {
	const getDataForType = () => {
		switch (type) {
			case "vat":
				return {
					title: 'Start-up VAT',
					price: 'Free'
				};
			case "sales tax":
				return {
					title: 'Free Sales Tax',
					price: 'Free'
				};
			case "epr":
				return {
					title: 'Free EPR',
					price: 'Free'
				};
			case "omp":
				return {
					title: 'Free OMP',
					price: 'Free'
				};
			case "invoice":
				return {
					title: 'Free Invoice',
					price: 'Free'
				};
			default:
				return {
					title: 'Free',
					price: 'Free'
				};
		}
	};

	const { title, price } = getDataForType();

	return (
		<div className="free-subscription-block">
			<div className="subscription-label">
				{title}
			</div>
			<div className="subscription-price">
				${price}
			</div>
			<Button
				variant="primary"
				size="micro"
				onClick={() => window.location.href = '/subscription'}
			>
				Get Premium
			</Button>
		</div>
	);
};

export default FreeSubscriptionBlock;
